
import React, { useEffect, useState } from 'react';
import { Route } from 'react-router';
import { NavLink } from 'react-router-dom';
import { fetchSinToken } from '../../helpers/fetch';
import { Loader } from '../loader/Loader';
import { NuevaContrasenia } from './NuevaContrasenia';

export const BodyNuevaContrasenia = ({match: { params }, ...rest}) => {
    const [loading, setLoading] = useState(true);
    const [parametros, setParametros] = useState({});
    const [valid, setValid] = useState(false);

    useEffect(() => {
        getParametros();
    }, []);

    const getParametros = async () => {
        const resp = await fetchSinToken(`passwordrecovery/${params.id}`);
        const data = await resp.json();
        if(!data.ok){
            setValid(false);
        } else{
            setParametros(data.data);
            setValid(true);
        }
        setLoading(false);
    }


    return (
        <Route {...rest}
        component={ (props)=>(
            loading ? <Loader />
            : valid ? <NuevaContrasenia  {...props} parametros={parametros}/>
                : <div className="text-center">
                    <h3 className="text-danger text-center mb-4">Esta url no es válido o ya venció</h3>
                    <NavLink to="/login" className="btn btn-primary">
                        <i className="fa fa-arrow-left"></i> Regresar a Login
                    </NavLink>
                </div>
        )}
        />
    )
}